import { FirebaseError } from 'firebase/app';

import NetworkError from './NetworkError';

/**
 * Did this failure describe the CONNECTION rather than the session?
 *
 * The two shapes a dropped transport takes here, one per host a renewal talks to:
 * `NetworkError` is our own XHR that went out and got nothing back, and
 * `auth/network-request-failed` is the ONE code Firebase mints about the wire rather than
 * the account — a token refresh that could not reach Google's endpoint. Everything else,
 * every other Firebase code included, is an ANSWER and must not be mistaken for a blip.
 *
 * The single chokepoint for that question (sen-3 M1): the session guard's
 * `isConnectivityFault` and `AuthProvider`'s `shouldRetryDroppedRenewal` both delegate
 * here, so the two can never again disagree about the same failure. Lives in `api/http`,
 * away from `axios.ts`, so `AuthProvider` can import it without pulling in the
 * axios/session-guard initialization.
 *
 * Deliberately not `navigator.onLine`: that answers "attached to a network", not "reached
 * the other end", and it is famously true on a captive portal.
 */
export function isConnectivityError(error: unknown) {
  return (
    error instanceof NetworkError ||
    (error instanceof FirebaseError &&
      error.code === 'auth/network-request-failed')
  );
}
